import React from 'react'

export const LoadingBlock = require('../Images/load-icon.svg')
export const ErrorBlock = require('../Images/error-icon.svg')

import styled from '../../../theme/styled'
import { ApolloError } from 'apollo-client'

export const LoadingWrapper = styled.div`
  text-align: center;
  font-weight: bold;
  width: 100%;
  color: ${({ theme }) => theme.colors.default};

  img {
    max-width: 200px;
    margin-bottom: 20px;
  }

  button {
    margin-top: 20px;
    border: 2px solid white;
    padding: 15px;

    color: white;
    background: transparent;

    font-size: 14px;
    font-family: proxima-nova, Georgia, sans-serif;
    font-weight: bold;
  }
`

const FullSize = styled.div`
  flex: 1 0 auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
`

export const Blinds = styled.div`
  flex: 1 0 auto;
  display: flex;
  flex-direction: column;

  align-items: center;
  justify-content: center;
  width: 100%;
  background: rgba(0, 0, 0, 0.5);
`

type IndicatorProps = {
  message?: string
  hideImage?: boolean
}

export function LoadingIndicator(props: IndicatorProps) {
  const message = props.message || 'loading'
  return (
    <FullSize>
      <LoadingWrapper>
        {!props.hideImage && <img src={LoadingBlock} alt="" />}
        <br />
        {message}
      </LoadingWrapper>
    </FullSize>
  )
}

type NoClickHandler = {
  onClick?: undefined
  btnText?: undefined
}

type WithClickHandler = {
  onClick?: () => void
  btnText: string
}

type ErrorIndicatorProps = {
  message: string
} & (WithClickHandler | NoClickHandler)

export function ErrorIndicator({
  message,
  onClick,
  btnText
}: ErrorIndicatorProps) {
  return (
    <FullSize>
      <Blinds>
        <LoadingWrapper style={{ color: 'white' }}>
          <img src={ErrorBlock} alt="" />
          <br />
          Error: {message}
          <br />
          {onClick && <button onClick={onClick}>{btnText}</button>}
        </LoadingWrapper>
      </Blinds>
    </FullSize>
  )
}

// Quick and dirty helper to render the correct component
export function renderIndicator(
  loading: boolean,
  error: ApolloError | undefined
) {
  if (loading) {
    return <LoadingIndicator />
  }

  if (error) {
    return <ErrorIndicator message={error.message} />
  }

  return null
}



// WEBPACK FOOTER //
// ./src/Components/Shared/LoadIndicators/index.tsx